<script>
import Dropdown from './Dropdown.vue'
import request from '@/utils/request'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: Dropdown, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        textField: {
            type: String,
            default: 'title',
        },
        valueField: {
            type: String,
            default: '_id',
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            options: [],
        }
    }, // End of Component > mounted

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        dataSegmentId(value) {
            if (value) {
                this.getRecords()
            }
        },
        model(value) {
            if (value) {
                let selectedItem = this.options.find(
                    (item) => item._id === value
                )

              if(!selectedItem)
              { return null}
                let tempKey=this.field.key.replace('Id','')

                this.$store.commit('updateField', {
                    key: tempKey,
                    value: selectedItem.title,
                })
                if(this.field.key=='occupationInfo.workTypeId')
                {
                    this.$store.commit('setValue', {
                        key: 'isIndustrial',
                        value: selectedItem.isIndustrial,
                    })

                    if (!selectedItem.isIndustrial) {
                        this.$store.commit('updateField', {
                            key: 'occupationInfo.industryId',
                            value: null,
                        })

                        this.$store.commit('updateField', {
                            key: 'occupationInfo.industry',
                            value: null,
                        })
                    }
                }


                // if (this.field.key == 'basicInfo.genderId') {
                //     console.log('FieldName ' + this.field.key)
                //     console.log('basicInfo.genderId ' + selectedItem.title)
                //
                //     this.$store.commit('updateField', {
                //         key: 'basicInfo.gender',
                //         value: selectedItem.title,
                //     })
                // }
                // if (this.field.key == 'contactInfo.stateId') {
                //     console.log('FieldName ' + this.field.key)
                //     console.log('contactInfo.stateId ' + selectedItem.title)
                //
                //     this.$store.commit('updateField', {
                //         key: 'contactInfo.state',
                //         value: selectedItem.title,
                //     })
                // }
                // if (this.field.key == 'occupationInfo.industryId') {
                //     console.log('FieldName ' + this.field.key)
                //     console.log(
                //         'occupationInfo.industryId ' + selectedItem.title
                //     )
                //
                //     this.$store.commit('updateField', {
                //         key: 'occupationInfo.industry',
                //         value: selectedItem.title,
                //     })
                // }
                // if (this.field.key == 'occupationInfo.workTypeId') {
                //     console.log('FieldName ' + this.field.key)
                //     console.log(
                //         'occupationInfo.industryId ' + selectedItem.title
                //     )
                //
                //     this.$store.commit('updateField', {
                //         key: 'occupationInfo.workType',
                //         value: selectedItem.title,
                //     })
                // }
            }
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
   created(){
        var some = this.field.key.split('.')
        if (this.field.customerDetails && this.field.customerDetails[some[0]][some[1]]){
            this.model = this.field.customerDetails[some[0]][some[1]]
            if (this.field.key == 'basicInfo.genderId' && this.field.customerDetails['gender']) {
                    this.$store.commit('updateField', {
                        key: 'basicInfo.gender',
                        value: this.field.customerDetails['gender'],
                    })
                }
            if (this.field.key == 'basicInfo.nationalityId' && this.field.customerDetails['nationality']) {
                 
                 this.$store.commit('updateField', {
                     key: 'basicInfo.nationality',
                     value: this.field.customerDetails['nationality'],
                 })
             }
             if (this.field.key == 'basicInfo.countryOfResidenceId' && this.field.customerDetails['countryOfResidence']) {
                 
                 this.$store.commit('updateField', {
                     key: 'basicInfo.countryOfResidence',
                     value: this.field.customerDetails['countryOfResidence'],
                 })
             }
            if (this.field.key == 'contactInfo.stateId' && this.field.customerDetails['state']) {
                   
                    this.$store.commit('updateField', {
                        key: 'contactInfo.state',
                        value: this.field.customerDetails['state'],
                    })
                }
            if (this.field.key == 'occupationInfo.industryId' && this.field.customerDetails['industry']) {
                   
                    this.$store.commit('updateField', {
                        key: 'occupationInfo.industry',
                        value: this.field.customerDetails['industry'],
                    })
                }
            if (this.field.key == 'occupationInfo.workTypeId' && this.field.customerDetails['workType']) {
                 
                    this.$store.commit('updateField', {
                        key: 'occupationInfo.workType',
                        value: this.field.customerDetails['workType'],
                    })
                  if(this.field.customerDetails['occupationInfo']['industryId']){
                    this.$store.commit('setValue', {
                    key: 'isIndustrial',
                    value: true,
                   })
                  }else{
                    this.$store.commit('setValue', {
                    key: 'isIndustrial',
                    value: false,
                   })
                  }
                }
        }
   },
    async mounted() {
        await this.getRecords()
        // await this.selectValue()
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        /**
         * get the dropdown values when required
         *
         * @return {void}
         */
        async getRecords() {
            try {
                // fetch the list of associated configurations
                if(this.field.isAssociation)
                {
                    let { data } = await request({
                        url: `/configurations/${this.field.association}`,
                        params: {
                            dataSegmentId: this.dataSegmentId,
                            status: 'active',
                            perPage: 1000,
                            ref: 'dropdown',
                        },
                    })

                    // update the local list of options
                    this.options = data.data
                }
                else
                {
                    let fieldOptions = [...this.field.options]

                    let tempArr= []
                    for(let i=0; i<fieldOptions.length;i++)
                    {
                        let tempObj={}

                        if(fieldOptions[i] && fieldOptions[i].text && fieldOptions[i].text!='')
                        {
                            tempObj._id=fieldOptions[i].value
                            tempObj.title=fieldOptions[i].text
                        }
                        tempArr.push(tempObj)
                    }
                    this.options=tempArr
                }

                if (this.field.type === 'isd-code') {
                    this.options = this.options.filter((item) => {
                        item.isdCodeTitle = `${item.title} (${item.isdCode})`
                        return item
                    })
                }

            } catch (error) {
                console.log(error)
            }
        }, // End of getRecords() method
        async selectValue()
        {
            if(this.$route.name=="self-registration-company-setup-profile")
            {
                if (this.field.key == 'occupationInfo.workTypeId') {

                    let selectedItem = this.options.find(
                        (item) => item.title === 'Salaried-General'
                    )
                    if(selectedItem)
                    {
                        this.$store.commit('updateField', {
                            key: 'occupationInfo.workTypeId',
                            value: selectedItem._id,
                        })
                        this.$store.commit('updateField', {
                            key: 'occupationInfo.workType',
                            value: selectedItem.title,
                        })
                    }
                }
            }
        }
    }, // End of Component > watch
}
</script>
